// This query used to be a finite query persisted under `firm-documents`.
// Keep the infinite-query cache on a separate root key so old localStorage data
// cannot hydrate into TanStack Query's `{ pages, pageParams }` shape.
export const FIRM_DOCUMENTS_QUERY_KEY = 'firm-documents-infinite';
export const FIRM_DOCUMENTS_QUERY_PAGE_SIZE = 50;
export const FIRM_DOCUMENTS_QUERY_STALE_TIME_MS = 30_000;
